import FactuFlowModuleHost from "../../pages/factuflow/FactuFlowModuleHost";

const route = {
  key: "factuflowHost",
  path: "/factuflow/*",
  component: FactuFlowModuleHost,
  permission: "factuflow.module.read",
  private: true,
  layout: "main",
  icon: "faFileInvoice",
  group: "factuflow",
  order: 10
};

export default route;
